import { palette } from '../palette';

export const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontSize: 13,
      minWidth: 100,
      boxShadow: 0,
      minHeight: 30,
      border: '1px solid',
      padding: '0px 25px',
      marginRight: '10px',
      lineHeight: 1,
      borderRadius: 0,
      borderColor: palette.primary.dark,
      '&$disabled': {
        color: 'white',
        backgroundColor: '#E5E7F3',
        minWidth: 100,
        minHeight: 30,
        padding: '0px 25px',
        border: '1px',
      },
    },
    containedPrimary: {
      backgroundColor: palette.primary.main,
      boxShadow: 'initial',
      color: 'white',
      border: 'none',
      '&:hover': {
        color: palette.primary.dark,
        backgroundColor: 'white',
        border: '1px solid',
        boxShadow: 'initial',
        borderColor: palette.primary.dark,
      },
    },
  },
};
